import accountApi from "@/api/account.api";

export const searchAccounts = async ({ query, limit = 24, offset = 0 }) => {
  return await accountApi.search(query, limit, offset);
};

export const getAccountList = async (params) => {
  return await accountApi.list(params);
};

export const getAccount = async (id) => {
  return await accountApi.get(id);
};

export const addAccount = async (data) => {
  return await accountApi.add(data);
};

export const createAccount = async (data) => {
  return await accountApi.store(data);
};

export const updateAccount = async (data) => {
  return await accountApi.update(data);
};

export const suspendAccount = async (id) => {
  return await accountApi.suspend(id);
};

export const reactivateAccount = async (id) => {
  return await accountApi.reactivate(id);
};

export const deleteAccount = async (id) => {
  return await accountApi.destroy(id);
};

export const deleteOwnAccount = async (id) => {
  return await accountApi.deleteOwnAccount(id);
};

export const getAccountStations = async (id, limit, offset) => {
  return await accountApi.getStations(id, limit, offset);
};

export const getAccountDeletedStations = async (id, limit, offset) => {
  return await accountApi.getStations(id, limit, offset,true);
};

export const getAccountUndeleteStation = async (id, stationKey) => {
  return await accountApi.getUndeleteStation(id, stationKey);
};

export const updateAccountUndeleteStation = async (id, stationKey) => {
  return await accountApi.updateUndeleteStation(id, stationKey);
};

export const getAccountCtlStations = async (id) => {
  return await accountApi.getCtlStations(id);
};

export const getAccountApplications = async (id) => {
  return await accountApi.getAccountApplications(id);
};

export const getAccountCustomLimits = async (id) => {
  return await accountApi.getCustomLimits(id);
};

export const updateAccountCustomLimits = async (data) => {
  return await accountApi.updateCustomLimits(data);
};

export const getAccountFeatureFlags = async (id) => {
  return await accountApi.getFeatureFlags(id);
};

export const updateAccountFeatureFlags = async (id, flags) => {
  return await accountApi.updateFeatureFlags(id, flags);
};

export const getAccountFeatureFlagDefinitions = async () => {
  return await accountApi.getFeatureFlagDefinitions();
};

export const getAccountAnalyticsSettings = async (accountKey) => {
  return await accountApi.getAnalyticsSettings(accountKey);
};

export const updateAccountAnalyticsSettings = async (accountKey, settings) => {
  return await accountApi.updateAnalyticsSettings(accountKey, settings);
};

export default {
  searchAccounts,
  getAccountList,
  getAccount,
  addAccount,
  createAccount,
  updateAccount,
  suspendAccount,
  reactivateAccount,
  deleteAccount,
  deleteOwnAccount,
  getAccountStations,
  getAccountDeletedStations,
  getAccountUndeleteStation,
  updateAccountUndeleteStation,
  getAccountCtlStations,
  getAccountApplications,
  getAccountCustomLimits,
  updateAccountCustomLimits,
  getAccountFeatureFlags,
  updateAccountFeatureFlags,
  getAccountFeatureFlagDefinitions,
  getAccountAnalyticsSettings,
  updateAccountAnalyticsSettings,
};
